import React from 'react';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Drawer from '@material-ui/core/Drawer';
import Grid from "@material-ui/core/Grid";
import {withStyles} from '@material-ui/core/styles';
import ApiFetcher from "../../ApiFetcher";
import HeatExchangerAddMenu from "./HeatExchangerAddMenu";
import HeatExchangerCleaningRange from "./HeatExchangerCleaningRange";
import HeatExchangerInfo from "./HeatExchangerInfo";
import HeatExchangerProcess from "./HeatExchangerProcess";
import Layout from "./Layout";
import LayoutSwitchList from "./LayoutSwitchList";
import LayoutName from "./LayoutName";
import UploadHeatExchangerToConstructionPlanDialog from "./UploadHeatExchangerToConstructionPlanDialog";
import LayoutDeleteButton from "./LayoutDeleteButton";
import PlantManagementUtility from "./PlantManagementUtility";
import Utility from "../../Utility";

const BLINK_TIMEOUT = 2000;
const INIT_POSITION_X_STRING = '100';
const INIT_POSITION_Y_STRING = '60';
const INIT_ANGLE_STRING = '0';
const LAYOUT_WIDTH = 1400;
const LAYOUT_HEIGHT = 550;
const DELETE_LAYOUT_BUTTON_HEIGHT = 30;

const styles = theme => ({
    functionButton: {
        margin: 'auto',
        padding: theme.spacing.unit
    },
    circularProgress: {
        textAlign: 'center',
        margin: theme.spacing.unit
    },
    dialogContainer: {
        margin: theme.spacing.unit
    },
    deleteLayoutButton: {
        display: "flex",
        margin: "auto",
        borderRadius: theme.spacing.unit,
        left: LAYOUT_WIDTH / 2 - DELETE_LAYOUT_BUTTON_HEIGHT,
        top: DELETE_LAYOUT_BUTTON_HEIGHT / 2,
        zIndex: 1 // レイアウトより上にする.
    },
    layoutWrapper: {
        marginTop: -DELETE_LAYOUT_BUTTON_HEIGHT - 10, // レイアウト削除ボタンの分.
        zIndex: 0 // レイアウト削除ボタンより下にする.
    },
    layoutSwitchList: {
        margin: 'auto',
        textAlign: 'center',
        padding: theme.spacing.unit,
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
    }
});

const CustomFunctionButton = (props) => {
    return (<Button onClick={props.onClick} href="" variant="contained" color="primary" fullWidth disabled ={props.disabled}>{props.label}</Button>)
};

const CustomGridItem = (props) => {
    return (<Grid item xs={props.xs} component={'div'} className={props.className}>{props.children}</Grid>)
};

export class LayoutEditor extends React.Component {
    constructor(props) {
        super(props);

        let params = new URLSearchParams(this.props.location.search);
        this.csvId = params.get("csvId");

        // ※refを使用するので@material-ui/coreのversion3.Xの場合,対象のコンポーネントがwithStylesでラッピングされていないことを確認すること.
        this.layoutRef = React.createRef();

        this.state = {
            heatExchangerArray: [],
            layoutArray: [],
            currentLayoutIndex: 0,
            currentEditSettingHeatExchangerId: null,
            isOpenSettingDialog: false,
            isOpenAddHeatExchangerDrawer: false,
            isOpenWaitDialog: true,
            isOpenUpdateErrorDialog: false,
            isOpenConfirmBackDialog: false,
            isOpenUploadHeatExchangerToConstructionPlanDialog: false,
        };

        this.backToSelectCsv = this.backToSelectCsv.bind(this);
        this.closeConfirmBackDialog = this.closeConfirmBackDialog.bind(this);
        this.getDataFromDB = this.getDataFromDB.bind(this);
        this.handleGetHeatExchanger = this.handleGetHeatExchanger.bind(this);
        this.handleGetNewSceneDetailNumber = this.handleGetNewSceneDetailNumber.bind(this);
        this.handleUpdateHeatExchanger = this.handleUpdateHeatExchanger.bind(this);
        this.onChangeHeatExchangerInfo = this.onChangeHeatExchangerInfo.bind(this);
        this.onClickAddHeatExchanger = this.onClickAddHeatExchanger.bind(this);
        this.onClickAddLayout = this.onClickAddLayout.bind(this);
        this.onClickBackToSelectCsv = this.onClickBackToSelectCsv.bind(this);
        this.onClickDecideChangeLayoutName = this.onClickDecideChangeLayoutName.bind(this);
        this.onClickHeatExchangerInHeatExchangerAddMenu = this.onClickHeatExchangerInHeatExchangerAddMenu.bind(this);
        this.onClickLayoutSwitch = this.onClickLayoutSwitch.bind(this);
        this.onClickLayoutRearrangeRight = this.onClickLayoutRearrangeRight.bind(this);
        this.onClickLayoutRearrangeLeft = this.onClickLayoutRearrangeLeft.bind(this);
        this.onClickReturnLayout = this.onClickReturnLayout.bind(this);
        this.onClickSync = this.onClickSync.bind(this);
        this.syncHeatExchanger = this.syncHeatExchanger.bind(this);
        this.onClickUpdateErrorDialogOk = this.onClickUpdateErrorDialogOk.bind(this);
        this.onCloseHeatExchangerAddMenu = this.onCloseHeatExchangerAddMenu.bind(this);
        this.onDecideDeleteCurrentLayout = this.onDecideDeleteCurrentLayout.bind(this);
        this.onDragMoveHeatExchangerInLayout = this.onDragMoveHeatExchangerInLayout.bind(this);
        this.onReleaseCarryOut = this.onReleaseCarryOut.bind(this);
        this.onTapOrClickHeatExchangerInLayoutBody = this.onTapOrClickHeatExchangerInLayoutBody.bind(this);
        this.updateHeatExchanger = this.updateHeatExchanger.bind(this);
        this.setViewNewLayout = this.setViewNewLayout.bind(this);
        this.onClickUploadHeatExchangerToConstructionPlan = this.onClickUploadHeatExchangerToConstructionPlan.bind(this);
        this.closeUploadHeatExchangerToConstructionPlanDialog = this.closeUploadHeatExchangerToConstructionPlanDialog.bind(this);

        if (this.props.onScreen !== undefined) {
            this.props.onScreen(
                '洗浄場レイアウト画面', // screenName.
                true, // plantManagementFlag.
                true // isNoHeaderAndFooter.
            );
        }
    }

    componentDidMount() {
        this.getDataFromDB();
    }

    backToSelectCsv() {
        this.props.history.push(this.props.backPath);
    }

    closeConfirmBackDialog() {
        this.setState({isOpenConfirmBackDialog: false});
    }

    getDataFromDB() {
        this.setState({isOpenWaitDialog: true}, () => {
            ApiFetcher.getHeatExchanger(this.props.cookies.get('token'), this.csvId, this.handleGetHeatExchanger);
        });
    }

    handleGetHeatExchanger(responseJson) {
        if (Utility.isNullOrUndefined(responseJson.result)) {
            // 画面が成立しないので工事計画CSV選択画面に戻す.
            alert('熱交の取得に失敗したため工事計画CSV選択画面に戻ります。');
            this.props.history.push(this.props.backPath);
        } else {
            let layoutArray = PlantManagementUtility.extractLayoutArrayOrderByAscFromHeatExchangerArray(responseJson.result.heatExchangerArray);
            // レイアウトが1つもなければ新規レイアウト番号を取得.
            if (layoutArray.length === 0) {
                if (Utility.isKecRole(this.props.cookies.get('role'))) {
                    this.setState({ heatExchangerArray: responseJson.result.heatExchangerArray, isOpenWaitDialog: true }, () => {
                        ApiFetcher.getNewSceneDetailNumber(this.props.cookies.get('token'), this.csvId, this.handleGetNewSceneDetailNumber);
                    });
                } else {
                    // 空の新規レイアウトの画面を表示するだけでデータの更新を行わないためsceneDetailNumberはダミー値
                    this.setViewNewLayout(1);
                }
            } else {
                this.setState({
                    heatExchangerArray: responseJson.result.heatExchangerArray,
                    layoutArray: layoutArray,
                    currentLayoutIndex: 0,
                    isOpenWaitDialog: false,
                });
            }
        }
    }

    handleGetNewSceneDetailNumber(responseJson) {
        if (Utility.isNullOrUndefined(responseJson.result)) {
            // 画面が成立しないので工事計画CSV選択画面に戻す.
            alert('新規レイアウト番号の取得に失敗したため工事計画CSV選択画面に戻ります。');
            this.props.history.push(this.props.backPath);
        } else {
            // 新規レイアウトを追加.
            this.setViewNewLayout(responseJson.result.sceneDetailNumber)
        }
    }

    handleUpdateHeatExchanger(responseJson) {
        if (responseJson.message !== null) {
            this.setState({isOpenUpdateErrorDialog: true});
        }
        this.setState({isOpenWaitDialog: false});
    }

    onChangeHeatExchangerInfo(newHeatExchanger) {
        this.updateHeatExchanger(newHeatExchanger, () => {
            this.setState({isOpenSettingDialog: false, currentEditSettingHeatExchangerId: null});
        });
    }

    onClickAddHeatExchanger() {
        this.setState({isOpenAddHeatExchangerDrawer: true});
    }

    onClickAddLayout() {
        this.setState({isOpenWaitDialog: true}, () => {
            ApiFetcher.getNewSceneDetailNumber(this.props.cookies.get('token'), this.csvId, this.handleGetNewSceneDetailNumber);
        });
    }

    onClickBackToSelectCsv() {
        this.setState({isOpenConfirmBackDialog: true});
    }

    onClickDecideChangeLayoutName(newLayoutName) {
        // 現在のレイアウトに配置されている熱交のIDの配列を取得.
        let targetHeatExchangerIdArray = PlantManagementUtility.getHeatExchangerIdArrayFilterBySceneDetailNumber(this.state.heatExchangerArray, this.state.layoutArray[this.state.currentLayoutIndex].sceneDetailNumber);

        // 現在のレイアウトに配置されている熱交の「現場名(詳細)」を変更する.
        let newHeatExchangerArray = Utility.getDeepCopy(this.state.heatExchangerArray);
        let updatedHeatExchangerArray = [];
        for (let i = 0; i < targetHeatExchangerIdArray.length; i++) {
            let targetIndex = PlantManagementUtility.getIndexOfHeatExchangerByHeatExchangerId(this.state.heatExchangerArray, targetHeatExchangerIdArray[i]);
            newHeatExchangerArray[targetIndex].sceneDetailName = newLayoutName;
            updatedHeatExchangerArray.push(newHeatExchangerArray[targetIndex]);
        }

        // 現在のレイアウトのレイアウト名を変更する.
        let newLayoutArray = Utility.getDeepCopy(this.state.layoutArray);
        newLayoutArray[this.state.currentLayoutIndex].sceneDetailName = newLayoutName;

        this.setState({heatExchangerArray: newHeatExchangerArray, layoutArray: newLayoutArray}, () => {
            if (updatedHeatExchangerArray.length !== 0) {
                ApiFetcher.updateHeatExchanger(this.props.cookies.get('token'), updatedHeatExchangerArray, this.handleUpdateHeatExchanger);
            }
        });
    }

    onClickHeatExchangerInHeatExchangerAddMenu(heatExchanger) {
        // 搬出済みであれば熱交状況設定画面を表示
        if (PlantManagementUtility.isParamTrue(heatExchanger.resultOfProcessIsCompleteCarryOut)) {
            this.setState({isOpenSettingDialog: true, currentEditSettingHeatExchangerId: heatExchanger.heatExchangerId, isOpenAddHeatExchangerDrawer: false});
        }
        // 配置済みであればレイアウト移動して点滅.
        else if (PlantManagementUtility.isDeployed(heatExchanger.sceneDetailNumber)) {
            this.layoutRef.current.startBlink(heatExchanger.heatExchangerId, BLINK_TIMEOUT);
            this.setState({currentLayoutIndex: PlantManagementUtility.getLayoutIndexBySceneDetailNumber(this.state.layoutArray, heatExchanger.sceneDetailNumber), isOpenAddHeatExchangerDrawer: false});
        }
        // 未配置であれば今のレイアウトに配置.
        else {
            let nowDatetimeString = Utility.getNowDatetimeString();
            let targetIndex = PlantManagementUtility.getIndexOfHeatExchangerByHeatExchangerId(this.state.heatExchangerArray, heatExchanger.heatExchangerId);
            let newHeatExchangerArray = Utility.getDeepCopy(this.state.heatExchangerArray);
            newHeatExchangerArray[targetIndex].sceneDetailNumber = this.state.layoutArray[this.state.currentLayoutIndex].sceneDetailNumber;
            newHeatExchangerArray[targetIndex].sceneDetailName = this.state.layoutArray[this.state.currentLayoutIndex].sceneDetailName;
            newHeatExchangerArray[targetIndex].resultOfProcessIsCompleteCarryIn = PlantManagementUtility.PARAM_BOOL.TRUE;
            newHeatExchangerArray[targetIndex].resultOfProcessCarryInDatetime = nowDatetimeString;
            newHeatExchangerArray[targetIndex].systemInfoPositionX = INIT_POSITION_X_STRING; // 必ず整数の文字列であること.
            newHeatExchangerArray[targetIndex].systemInfoPositionY = INIT_POSITION_Y_STRING; // 必ず整数の文字列であること.
            newHeatExchangerArray[targetIndex].systemInfoRotation = INIT_ANGLE_STRING;

            // propの変化では再描画されないためstate.xとstate.yの更新を行う.
            this.layoutRef.current.setHeatExchangerPosition(heatExchanger.heatExchangerId, INIT_POSITION_X_STRING, INIT_POSITION_Y_STRING);

            // 最前面に表示する.
            this.layoutRef.current.moveToTop(heatExchanger.heatExchangerId);

            this.setState({heatExchangerArray: newHeatExchangerArray, isOpenAddHeatExchangerDrawer: false}, () => {
                ApiFetcher.updateHeatExchanger(this.props.cookies.get('token'), [newHeatExchangerArray[targetIndex]], this.handleUpdateHeatExchanger);
            });
        }
    }

    onClickLayoutSwitch(layout) {
        this.layoutRef.current.stopBlink(); // 点滅を停止させる.
        this.setState({currentLayoutIndex: PlantManagementUtility.getLayoutIndexBySceneDetailNumber(this.state.layoutArray, layout.sceneDetailNumber)});
    }

    onClickLayoutRearrangeRight() {
        // レイアウトの右端以外
        if (this.state.currentLayoutIndex + 1 < this.state.layoutArray.length) {
            this.setState({isOpenWaitDialog: true});
            this.layoutRef.current.stopBlink(); // 点滅を停止させる.

            const currentSceneDetailNumber = this.state.layoutArray[this.state.currentLayoutIndex].sceneDetailNumber;
            const nextLayoutIndex = this.state.currentLayoutIndex + 1;
            const rightLayoutSceneDetailNumber = this.state.layoutArray[nextLayoutIndex].sceneDetailNumber;

            // 現在のレイアウトに配置されている熱交のIDの配列を取得.
            const currentLayoutHeatExchangerIdArray = PlantManagementUtility.getHeatExchangerIdArrayFilterBySceneDetailNumber(this.state.heatExchangerArray, currentSceneDetailNumber);
            // 並び替え先のレイアウトに配置されている熱交のIDの配列を取得.
            const nextLayoutHeatExchangerIdArray = PlantManagementUtility.getHeatExchangerIdArrayFilterBySceneDetailNumber(this.state.heatExchangerArray, rightLayoutSceneDetailNumber);

            const newHeatExchangerArray = Utility.getDeepCopy(this.state.heatExchangerArray);
            const updatedHeatExchangerArray = [];

            // 現在のレイアウトに配置されている熱交のレイアウト番号を並び替え先のレイアウト番号に変更する.
            for (let i = 0; i < currentLayoutHeatExchangerIdArray.length; i++) {
                const targetIndex = PlantManagementUtility.getIndexOfHeatExchangerByHeatExchangerId(this.state.heatExchangerArray, currentLayoutHeatExchangerIdArray[i]);
                newHeatExchangerArray[targetIndex].sceneDetailNumber = rightLayoutSceneDetailNumber;
                updatedHeatExchangerArray.push(newHeatExchangerArray[targetIndex]);
            }
            
            // 並び替え先のレイアウトに配置されている熱交のレイアウト番号を現在のレイアウト番号に変更する.
            for (let i = 0; i < nextLayoutHeatExchangerIdArray.length; i++) {
                const targetIndex = PlantManagementUtility.getIndexOfHeatExchangerByHeatExchangerId(this.state.heatExchangerArray, nextLayoutHeatExchangerIdArray[i]);
                newHeatExchangerArray[targetIndex].sceneDetailNumber = currentSceneDetailNumber;
                updatedHeatExchangerArray.push(newHeatExchangerArray[targetIndex]);
            }

            //レイアウトの配列の並び替え元と並び替え先の入れ替え
            const newLayoutArray = Utility.getDeepCopy(this.state.layoutArray);
            const currentLayout = this.state.layoutArray[this.state.currentLayoutIndex];
            const targetLayout = this.state.layoutArray[nextLayoutIndex];
            currentLayout.sceneDetailNumber = targetLayout.sceneDetailNumber;
            targetLayout.sceneDetailNumber = currentSceneDetailNumber;
            newLayoutArray[this.state.currentLayoutIndex] = targetLayout;
            newLayoutArray[nextLayoutIndex] = currentLayout;
            this.setState({heatExchangerArray: newHeatExchangerArray, layoutArray: newLayoutArray, currentLayoutIndex: PlantManagementUtility.getLayoutIndexBySceneDetailNumber(newLayoutArray, rightLayoutSceneDetailNumber)}, () => {
                if (updatedHeatExchangerArray.length !== 0) {
                    ApiFetcher.updateHeatExchanger(this.props.cookies.get('token'), updatedHeatExchangerArray, this.handleUpdateHeatExchanger);
                } else {
                    this.setState({isOpenWaitDialog: false});
                }
            });
        }
    }

    onClickLayoutRearrangeLeft() {
        // レイアウトの左端以外
        if (this.state.currentLayoutIndex !== 0) {
            this.setState({isOpenWaitDialog: true});
            this.layoutRef.current.stopBlink(); // 点滅を停止させる.

            const currentSceneDetailNumber = this.state.layoutArray[this.state.currentLayoutIndex].sceneDetailNumber;
            const leftLayoutIndex = this.state.currentLayoutIndex - 1;
            const leftLayoutSceneDetailNumber = this.state.layoutArray[leftLayoutIndex].sceneDetailNumber;

            // 現在のレイアウトに配置されている熱交のIDの配列を取得.
            const currentLayoutHeatExchangerIdArray = PlantManagementUtility.getHeatExchangerIdArrayFilterBySceneDetailNumber(this.state.heatExchangerArray, currentSceneDetailNumber);
            // 並び替え先のレイアウトに配置されている熱交のIDの配列を取得.
            const nextLayoutHeatExchangerIdArray = PlantManagementUtility.getHeatExchangerIdArrayFilterBySceneDetailNumber(this.state.heatExchangerArray, leftLayoutSceneDetailNumber);

            const newHeatExchangerArray = Utility.getDeepCopy(this.state.heatExchangerArray);
            const updatedHeatExchangerArray = [];

            // 現在のレイアウトに配置されている熱交のレイアウト番号を並び替え先のレイアウト番号に変更する.
            for (let i = 0; i < currentLayoutHeatExchangerIdArray.length; i++) {
                const targetIndex = PlantManagementUtility.getIndexOfHeatExchangerByHeatExchangerId(this.state.heatExchangerArray, currentLayoutHeatExchangerIdArray[i]);
                newHeatExchangerArray[targetIndex].sceneDetailNumber = leftLayoutSceneDetailNumber;
                updatedHeatExchangerArray.push(newHeatExchangerArray[targetIndex]);
            }
            
            // 並び替え先のレイアウトに配置されている熱交のレイアウト番号を現在のレイアウト番号に変更する.
            for (let i = 0; i < nextLayoutHeatExchangerIdArray.length; i++) {
                const targetIndex = PlantManagementUtility.getIndexOfHeatExchangerByHeatExchangerId(this.state.heatExchangerArray, nextLayoutHeatExchangerIdArray[i]);
                newHeatExchangerArray[targetIndex].sceneDetailNumber = currentSceneDetailNumber;
                updatedHeatExchangerArray.push(newHeatExchangerArray[targetIndex]);
            }

            //レイアウトの配列の並び替え元と並び替え先の入れ替え
            const newLayoutArray = Utility.getDeepCopy(this.state.layoutArray);
            const currentLayout = this.state.layoutArray[this.state.currentLayoutIndex];
            const targetLayout = this.state.layoutArray[leftLayoutIndex];
            currentLayout.sceneDetailNumber = targetLayout.sceneDetailNumber;
            targetLayout.sceneDetailNumber = currentSceneDetailNumber;
            newLayoutArray[this.state.currentLayoutIndex] = targetLayout;
            newLayoutArray[leftLayoutIndex] = currentLayout;
            this.setState({heatExchangerArray: newHeatExchangerArray, layoutArray: newLayoutArray, currentLayoutIndex: PlantManagementUtility.getLayoutIndexBySceneDetailNumber(newLayoutArray, leftLayoutSceneDetailNumber)}, () => {
                if (updatedHeatExchangerArray.length !== 0) {
                    ApiFetcher.updateHeatExchanger(this.props.cookies.get('token'), updatedHeatExchangerArray, this.handleUpdateHeatExchanger);
                } else {
                    this.setState({isOpenWaitDialog: false});
                }
            });
        }
    }

    onClickReturnLayout() {
        this.setState({isOpenSettingDialog: false, currentEditSettingHeatExchangerId: null});
    }

    onClickSync() {
        this.setState({heatExchangerArray: [], layoutArray: [], currentLayoutIndex: 0}, () => {
            this.getDataFromDB();
        });
    }

    syncHeatExchanger() {
        this.setState({ heatExchangerArray: [], layoutArray: [], currentLayoutIndex: 0 }, () => {
            this.getDataFromDB();
        });
    }

    onClickUpdateErrorDialogOk() {
        this.setState({isOpenUpdateErrorDialog: false}, () => {
            this.onClickSync();
        });
    }

    onCloseHeatExchangerAddMenu() {
        this.setState({isOpenAddHeatExchangerDrawer: false});
    }

    onDecideDeleteCurrentLayout() {
        let deleteTargetSceneDetailNumber = this.state.layoutArray[this.state.currentLayoutIndex].sceneDetailNumber;

        // 現在のレイアウトに配置されている熱交のIDの配列を取得.
        let targetHeatExchangerIdArray = PlantManagementUtility.getHeatExchangerIdArrayFilterBySceneDetailNumber(this.state.heatExchangerArray, deleteTargetSceneDetailNumber);
        // 現在のレイアウトに配置されている熱交を未配置にする.
        let newHeatExchangerArray = Utility.getDeepCopy(this.state.heatExchangerArray);
        let updatedHeatExchangerArray = [];
        for (let i = 0; i < targetHeatExchangerIdArray.length; i++) {
            let targetIndex = PlantManagementUtility.getIndexOfHeatExchangerByHeatExchangerId(this.state.heatExchangerArray, targetHeatExchangerIdArray[i]);
            newHeatExchangerArray[targetIndex].sceneDetailNumber = PlantManagementUtility.NOT_DEPLOY_LAYOUT;
            newHeatExchangerArray[targetIndex].sceneDetailName = '';
            updatedHeatExchangerArray.push(newHeatExchangerArray[targetIndex]);
        }

        // レイアウトの配列から現在のレイアウトを削除.
        let newLayoutArray = PlantManagementUtility.getLayoutArrayRejectBySceneDetailNumber(this.state.layoutArray, deleteTargetSceneDetailNumber);
        // 削除後に表示するレイアウトのインデックスを決定.
        let displayTargetLayoutIndex = PlantManagementUtility.getDisplayTargetLayoutIndexWhenDeleteLayout(this.state.layoutArray, deleteTargetSceneDetailNumber);

        this.setState({heatExchangerArray: newHeatExchangerArray, layoutArray: newLayoutArray, currentLayoutIndex: displayTargetLayoutIndex}, () => {
            if (updatedHeatExchangerArray.length !== 0) {
                ApiFetcher.updateHeatExchanger(this.props.cookies.get('token'), updatedHeatExchangerArray, this.handleUpdateHeatExchanger);
            }
        });
    }

    onDragMoveHeatExchangerInLayout(newHeatExchanger, targetLayoutIndex) {
        this.updateHeatExchanger(newHeatExchanger, () => {
            this.setState({currentLayoutIndex: targetLayoutIndex});
        });
    }

    onReleaseCarryOut(newHeatExchanger) {
        // 搬出解除の場合は熱交状況設定画面を閉じない.
        this.updateHeatExchanger(newHeatExchanger);
    }

    onTapOrClickHeatExchangerInLayoutBody(heatExchanger) {
        this.setState({isOpenSettingDialog: true, currentEditSettingHeatExchangerId: heatExchanger.heatExchangerId});
    }

    updateHeatExchanger(heatExchanger, callback) {
        let targetIndex = PlantManagementUtility.getIndexOfHeatExchangerByHeatExchangerId(this.state.heatExchangerArray, heatExchanger.heatExchangerId);

        let newHeatExchangerArray = Utility.getDeepCopy(this.state.heatExchangerArray);
        newHeatExchangerArray[targetIndex] = heatExchanger;

        this.setState({heatExchangerArray: newHeatExchangerArray}, () => {
            ApiFetcher.updateHeatExchanger(this.props.cookies.get('token'), [newHeatExchangerArray[targetIndex]], this.handleUpdateHeatExchanger);
            if (callback !== undefined) {
                callback();
            }
        });
    }

    setViewNewLayout(sceneDetailNumber) {
        let newLayout = { sceneDetailName: '新規レイアウト', sceneDetailNumber: sceneDetailNumber };
        let newLayoutArray = Utility.getDeepCopy(this.state.layoutArray);
        let length = newLayoutArray.push(newLayout);
        this.setState({
            layoutArray: newLayoutArray,
            currentLayoutIndex: length - 1,
            isOpenWaitDialog: false
        });
    }

    onClickUploadHeatExchangerToConstructionPlan() {
        this.setState({ isOpenUploadHeatExchangerToConstructionPlanDialog: true })
    }

    closeUploadHeatExchangerToConstructionPlanDialog() {
        this.setState({ isOpenUploadHeatExchangerToConstructionPlanDialog: false })
    }

    render() {
        // 初期状態ではボタンなどを非活性にする
        let isDisabled = true;
        // KECアカウントの場合は非活性にしない
        if (Utility.isKecRole(this.props.cookies.get('role'))){
            isDisabled = false;
        }
        const {classes} = this.props;
        const {heatExchangerArray, isOpenSettingDialog, currentEditSettingHeatExchangerId, layoutArray, currentLayoutIndex, isOpenAddHeatExchangerDrawer, isOpenWaitDialog} = this.state;
        const currentEditSettingHeatExchanger = PlantManagementUtility.getHeatExchangerByHeatExchangerId(heatExchangerArray, currentEditSettingHeatExchangerId);
        return (
            <div>
                <Grid container component={'div'}>
                    <CustomGridItem xs={2} className={classes.functionButton}>
                        <CustomFunctionButton label="現場選択(戻る)" onClick={this.onClickBackToSelectCsv} disabled={false}/>
                    </CustomGridItem>
                    <CustomGridItem xs={4} className={classes.functionButton}>
                        <LayoutName
                            layoutName={layoutArray.length === 0 ? '' : layoutArray[currentLayoutIndex].sceneDetailName}
                            onClickDecideChange={this.onClickDecideChangeLayoutName} isDisabled={isDisabled}
                        />
                    </CustomGridItem>
                    <CustomGridItem xs={2} className={classes.functionButton}>
                        <CustomFunctionButton label="熱交追加" onClick={this.onClickAddHeatExchanger} disabled={isDisabled}/>
                    </CustomGridItem>
                    <CustomGridItem xs={2} className={classes.functionButton}>
                        <CustomFunctionButton label="同期" onClick={this.onClickSync} disabled={isDisabled}/>
                    </CustomGridItem>
                    <CustomGridItem xs={2} className={classes.functionButton}>
                        <CustomFunctionButton label="新規熱交登録" onClick={this.onClickUploadHeatExchangerToConstructionPlan} disabled={isDisabled} />
                    </CustomGridItem>
                </Grid>
                {layoutArray.length !== 0 &&
                <div>
                    <LayoutDeleteButton
                        className={classes.deleteLayoutButton}
                        layoutArrayLength={this.state.layoutArray.length}
                        onClickDecide={this.onDecideDeleteCurrentLayout}
                        isDisabled={isDisabled}
                    />
                    <div className={classes.layoutWrapper}>
                        <Layout 
                            draggable
                            ref={this.layoutRef}
                            width={LAYOUT_WIDTH}
                            height={LAYOUT_HEIGHT}
                            currentSceneDetailNumber={layoutArray[currentLayoutIndex].sceneDetailNumber}
                            heatExchangerArray={heatExchangerArray}
                            onTapOrClickHeatExchangerInLayoutBody={this.onTapOrClickHeatExchangerInLayoutBody}
                            onTapOrClickHeatExchangerInLayoutRotationArrow={this.updateHeatExchanger}
                            onDragEndHeatExchangerInLayout={this.updateHeatExchanger}
                            onMoveLayoutHeatExchangerInLayout={this.onDragMoveHeatExchangerInLayout}
                            layoutArray={this.state.layoutArray}
                            currentLayoutIndex={this.state.currentLayoutIndex}
                            isDisabled={isDisabled}
                        />
                    </div>
                    <LayoutSwitchList
                        currentLayoutIndex={currentLayoutIndex}
                        layoutArray={layoutArray}
                        onClickLayout={this.onClickLayoutSwitch}
                        onClickAdd={this.onClickAddLayout}
                        onClickLayoutRearrangeRight={this.onClickLayoutRearrangeRight}
                        onClickLayoutRearrangeLeft={this.onClickLayoutRearrangeLeft}
                        className={classes.layoutSwitchList}
                        isDisabled={isDisabled}

                    />
                    <Drawer
                        anchor="right"
                        open={isOpenAddHeatExchangerDrawer}
                        onClose={this.onCloseHeatExchangerAddMenu}
                    >
                        <HeatExchangerAddMenu
                            heatExchangerArray={heatExchangerArray}
                            onClickDecideAddNoPlanHeatExchanger={this.updateHeatExchanger}
                            onClickHeatExchanger={this.onClickHeatExchangerInHeatExchangerAddMenu}
                        />
                    </Drawer>
                    {currentEditSettingHeatExchangerId !== null &&
                    <Dialog fullScreen open={isOpenSettingDialog}>
                        <div className={classes.dialogContainer}>
                            <HeatExchangerInfo
                                heatExchanger={currentEditSettingHeatExchanger}
                                onClickCarryOut={this.onChangeHeatExchangerInfo}
                                onClickPutBack={this.onChangeHeatExchangerInfo}
                                onClickReleaseCarryOut={this.onReleaseCarryOut}
                                onClickReturnLayout={this.onClickReturnLayout}
                                onChangeHeatExchanger={this.updateHeatExchanger}
                            />
                            <HeatExchangerCleaningRange
                                heatExchanger={currentEditSettingHeatExchanger}
                                onChangeHeatExchanger={this.updateHeatExchanger}
                            />
                            <HeatExchangerProcess
                                heatExchanger={currentEditSettingHeatExchanger}
                                onChangePretestComplete={this.updateHeatExchanger}
                                onChangeAirBlowComplete={this.updateHeatExchanger}
                                onChangeEtComplete={this.updateHeatExchanger}
                                onChangeFtectComplete={this.updateHeatExchanger}
                                onChangeIrisComplete={this.updateHeatExchanger}
                            />
                        </div>
                    </Dialog>
                    }
                </div>
                }
                {isOpenWaitDialog &&
                <Dialog open={true} fullWidth maxWidth={"xs"}>
                    <DialogContent style={{textAlign: 'center'}}>
                        <CircularProgress/>
                    </DialogContent>
                </Dialog>
                }
                <Dialog open={this.state.isOpenUpdateErrorDialog}>
                    <DialogTitle>更新エラー</DialogTitle>
                    <DialogContent>
                        <DialogContentText>更新エラーが発生したため、熱交同期を行います。<br/>同期後に再度操作を行ってください。</DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button fullWidth onClick={this.onClickUpdateErrorDialogOk} color="primary" variant="contained">OK</Button>
                    </DialogActions>
                </Dialog>
                <Dialog open={this.state.isOpenConfirmBackDialog} onClose={this.closeConfirmBackDialog}>
                    <DialogTitle>現場選択(戻る)</DialogTitle>
                    <DialogContent>
                        <DialogContentText>工事計画CSV選択画面に戻ります。本当によろしいですか？</DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button fullWidth onClick={this.closeConfirmBackDialog} color="secondary" variant="contained">いいえ</Button>
                        <Button fullWidth onClick={this.backToSelectCsv} color="primary" variant="contained">はい</Button>
                    </DialogActions>
                </Dialog>
                <UploadHeatExchangerToConstructionPlanDialog
                    isDisabled={isDisabled}
                    open={this.state.isOpenUploadHeatExchangerToConstructionPlanDialog}
                    closeDialog={this.closeUploadHeatExchangerToConstructionPlanDialog}
                    cookies={this.props.cookies}
                    csvId={this.csvId}
                    syncHeatExchanger={this.syncHeatExchanger}
                />
            </div>
        );
    }
}

export default withStyles(styles)(LayoutEditor);
